export default __webpack_public_path__ + "static/media/nordstrom.cbeaf075.png";